// import addJcRecord from '../components/superviseJc/addJcRecord.vue'
// import jcRecordList from '../components/superviseJc/jcRecordList.vue'
// import superviseQyList from '../components/superviseJc/superviseQyList.vue'
// import viewSuperviseQy from '../components/superviseJc/viewSuperviseQy.vue'

export default [
    {
        path: 'superviseJc/addJcRecord',
        component: resolve => require(['@/components/superviseJc/addJcRecord'],resolve),
        name:"AddJcRecord",
        meta:{
            id:'665',
            node:'superviseJc',
            url:'addJcRecord',
        }
    },
    {
        path: 'superviseJc/jcRecordList',
        component: resolve => require(['@/components/superviseJc/jcRecordList'],resolve),
        name:"JcRecordList",
        meta:{
            id:'663',
            node:'superviseJc',
            url:'jcRecordList',
        }
    },
    {
        path: 'superviseJc/superviseQyList',
        component: resolve => require(['@/components/superviseJc/superviseQyList'],resolve),
        name:"SuperviseQyList",
        meta:{
            id:'660',
            node:'superviseJc',
            url:'superviseQyList',
        }
    },
    {
        path: 'superviseJc/viewSuperviseQy',
        component: resolve => require(['@/components/superviseJc/viewSuperviseQy'],resolve),
        name:"ViewSuperviseQy",
        meta:{
            id:'662',
            node:'superviseJc',
            url:'viewSuperviseQy',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/superviseJc.js